export default {
  PRIMARY: 'Avenir, sans-serif',
  SECONDARY: `'DM Serif Display', serif`
}
